import { FC, ReactElement } from 'react'

import { Page } from '@/components'
import { ConnectedLeaveRequestForm } from '@/connectors'

export const LeaveRequestPage: FC = (): ReactElement => (
    <Page className="leave-request-page">
        <ConnectedLeaveRequestForm />
    </Page>
)
